import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Accessibility.css';

export default function AccessibilityToolbar({ isOpen, onClose }) {
  const { t } = useLanguage();
  const [fontSize, setFontSize] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('portal_accessibility') || '{}');
      return saved.fontSize || 'normal';
    } catch {
      return 'normal';
    }
  });

  const [contrast, setContrast] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('portal_accessibility') || '{}');
      return saved.contrast || 'normal';
    } catch {
      return 'normal';
    }
  });

  // Apply classes to document.body whenever state changes
  useEffect(() => {
    // Remove all previous accessibility classes
    document.body.classList.remove('access-font-md', 'access-font-lg', 'access-contrast-mono', 'access-contrast-high');

    if (fontSize === 'md') {
      document.body.classList.add('access-font-md');
    } else if (fontSize === 'lg') {
      document.body.classList.add('access-font-lg');
    }

    if (contrast === 'mono') {
      document.body.classList.add('access-contrast-mono');
    } else if (contrast === 'high') {
      document.body.classList.add('access-contrast-high');
    }

    // Persist to localStorage
    try {
      localStorage.setItem('portal_accessibility', JSON.stringify({ fontSize, contrast }));
    } catch (e) {
      console.warn('Could not save accessibility preferences', e);
    }
  }, [fontSize, contrast]);

  const handleReset = () => {
    setFontSize('normal');
    setContrast('normal');
  };

  if (!isOpen) return null;

  return (
    <div className="accessibility-bar-panel" role="region" aria-label="Koʻrish imkoniyati cheklanganlar uchun sozlamalar">
      <div className="access-panel-container">
        {/* Shrift oʻlchami */}
        <div className="access-group">
          <span className="access-group-label">👁️ {t('Shrift hajmi:', 'Shrift hajmi:')}</span>
          <div className="access-btn-group">
            <button
              type="button"
              className={`access-opt-btn ${fontSize === 'normal' ? 'active' : ''}`}
              onClick={() => setFontSize('normal')}
              title={t('Standart shrift oʻlchami (100%)', 'Standart shrift oʻlchami (100%)')}
            >
              {t('A- Standart', 'A- Standart')}
            </button>
            <button
              type="button"
              className={`access-opt-btn ${fontSize === 'md' ? 'active' : ''}`}
              onClick={() => setFontSize('md')}
              title={t('Kattalashtirilgan shrift (115%)', 'Kattalashtirilgan shrift (115%)')}
            >
              {t('A Oʻrtacha', 'A Oʻrtacha')}
            </button>
            <button
              type="button"
              className={`access-opt-btn ${fontSize === 'lg' ? 'active' : ''}`}
              onClick={() => setFontSize('lg')}
              title={t('Katta shrift (130%)', 'Katta shrift (130%)')}
            >
              {t('A+ Katta', 'A+ Katta')}
            </button>
          </div>
        </div>

        {/* Rang va kontrast */}
        <div className="access-group">
          <span className="access-group-label">🎨 {t('Rang va kontrast:', 'Rang va kontrast:')}</span>
          <div className="access-btn-group">
            <button
              type="button"
              className={`access-opt-btn ${contrast === 'normal' ? 'active' : ''}`}
              onClick={() => setContrast('normal')}
              title={t('Odatiy rangli rejim', 'Odatiy rangli rejim')}
            >
              {t('Odatiy', 'Odatiy')}
            </button>
            <button
              type="button"
              className={`access-opt-btn ${contrast === 'mono' ? 'active' : ''}`}
              onClick={() => setContrast('mono')}
              title={t('Oq-qora (monoxrom) rejim', 'Oq-qora (monoxrom) rejim')}
            >
              ⬛ {t('Oq-qora', 'Oq-qora')}
            </button>
            <button
              type="button"
              className={`access-opt-btn ${contrast === 'high' ? 'active' : ''}`}
              onClick={() => setContrast('high')}
              title={t('Qora fonda sariq matnli yuqori kontrast rejim', 'Qora fonda sariq matnli yuqori kontrast rejim')}
            >
              🔲 {t('Yuqori kontrast', 'Yuqori kontrast')}
            </button>
          </div>
        </div>

        {/* Asliga qaytarish va Yopish */}
        <div className="access-group">
          {(fontSize !== 'normal' || contrast !== 'normal') && (
            <button
              type="button"
              className="access-reset-btn"
              onClick={handleReset}
              title={t('Barcha sozlamalarni tiklash', 'Barcha maxsus sozlamalarni standart holatga qaytarish')}
            >
              ↺ {t('Sozlamalarni tiklash', 'Qaytarish')}
            </button>
          )}
          <button
            type="button"
            className="access-close-btn"
            onClick={onClose}
            title="Maxsus imkoniyatlar panelini yopish"
            aria-label="Yopish"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
